module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"questions":"вопросов | вопрос | вопроса | вопросов","minutes":"мин","selected":"Выбрано"}}')
  delete Component.options._Ctor
}
